__turbopack_context__.v({
  "button": "TextButton-module-scss-module__EL5NxW__button",
  "default": "TextButton-module-scss-module__EL5NxW__default",
  "highlight": "TextButton-module-scss-module__EL5NxW__highlight",
});
